<!--精准读书会-->
<template>
    <div class="event-nav-container">
        <!--读书会分类(1-12月主题)-->
        <div class="museum-title-container111" v-show="showMode==='page'">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container">精准读书会</div>
                <div class="l-b-museum-title-container">1-12月主题阅读活动</div>
            </div>
            <div class="r-museum-title-container">
                <div class="back-btn-container" @click="backReadMuseum">⇦返回</div>
            </div>
        </div>
        <div class="event-content-container" v-show="showMode==='page'" v-loading="loading">
            <div class="event-content-top-container">
                <div class="event-item-container" v-for="(item,index) in itemList.slice(0,6)" :key="index" @click="pageMyjr(item)">
                    <div class="event-item" :class="'read-bg'+(index+1)">
                        <div class="event-title">{{item.itemMonth}}</div>
                        <div class="event-desc">{{item.itemName}}</div>
                        <div class="event-desc">{{item.itemDesc}}</div>
                    </div>
                </div>
            </div>
            <div class="event-content-bottom-container">
                <div class="event-item-container" v-for="(item,index) in itemList.slice(6,12)" :key="index" @click="pageMyjr(item)">
                    <div class="event-item" :class="'read-bg'+(index+7)">
                        <div class="event-title">{{item.itemMonth}}</div>
                        <div class="event-desc">{{item.itemName}}</div>
                        <div class="event-desc">{{item.itemDesc}}</div>
                    </div>
                </div>
            </div>
        </div>

        <!--读书会活动列表-->
        <div class="content-container" v-show="showMode==='list'">
            <read-club-page :item-info="currentItem"
                            :mark-info="subMarkInfo"
                            @back-page="backToPage"
                            @view-info="viewEventInfo"/>
        </div>

        <!--读书会活动详情-->
        <div class="content-container" v-show="showMode==='info'">
            <read-club-info :event-id="eventId"
                            :mark-info="subMarkInfo"
                            @back-page="backToList"/>
        </div>
    </div>
</template>
<script>
import {listItem} from "@/api/admin/museum"
import readClubPage from "@/components/museumEvent/readClubPage.vue";
import readClubInfo from "@/components/museumEvent/readClubInfo.vue";

export default {
    name:'readEventClub',
    components:{readClubPage, readClubInfo},
    props:{
        museumId:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        museumId(newValue,oldValue){
            this.showMode = 'page';
            this.queryItemList();
        },
        markInfo(newValue,oldValue){
            this.showMode = 'page';
            this.queryItemList();
        },
    },
    mounted() {
    },
    created() {
        this.queryItemList();
    },
    data() {
        return {
            showMode:'page',
            loading:false,
            itemList:[],
            currentItem:{},
            eventId:'',
            subMarkInfo:'',
            queryItemForm:{
                itemType:'1',
                museumKey:'1',
            },
        }
    },
    methods: {
        /*查询读书会分类(1-12月主题)*/
        queryItemList(){
            this.loading = true;
            this.queryItemForm.museumKey = this.museumId || '1';
            listItem(this.queryItemForm).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data || [];
                }else {
                    this.$message.error(res.data.msg || "请求出错")
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /*查看主题读书会活动列表*/
        pageMyjr(item){
            this.currentItem = item;
            this.subMarkInfo = new Date() + '';
            this.showMode = 'list';
        },
        /*查看读书会活动详情*/
        viewEventInfo(item){
            this.eventId = item.eventId;
            this.subMarkInfo = new Date() + '';
            this.showMode = 'info';
        },
        backToPage(){
            this.showMode = 'page';
        },
        backToList(){
            this.showMode = 'list';
        },
        backReadMuseum(){
            this.showMode = 'page';
            this.$emit('back-read-museum', "homePage");
        },
    }
}
</script>
<style scoped>
.event-nav-container{
    width: 100%;
    height: calc(100vh - 90px);
    background: rgba(255,255,255,.5);
    border-radius: 28px;

}
.museum-title-container111{
    width: 100%;
    height: 70px;
    display: flex;
    box-sizing: border-box;
    padding: 0 30px 0 30px!important;

}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #ff7f2e;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.event-content-container{
    width: 100%;
    height: calc(100% - 70px);
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
}
.event-content-top-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-item-container{
    width: 16.6%;
    height: 100%;
    display: flex;
    border: 10px;
    box-sizing: border-box;
}
.event-item{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.read-bg1{
    background-image: url("../../assets/dsh/dsh_1.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg2{
    background-image: url("../../assets/dsh/dsh_2.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg3{
    background-image: url("../../assets/dsh/dsh_3.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg4{
    background-image: url("../../assets/dsh/dsh_4.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg5{
    background-image: url("../../assets/dsh/dsh_5.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg6{
    background-image: url("../../assets/dsh/dsh_6.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg7{
    background-image: url("../../assets/dsh/dsh_7.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg8{
    background-image: url("../../assets/dsh/dsh_8.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg9{
    background-image: url("../../assets/dsh/dsh_9.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg10{
    background-image: url("../../assets/dsh/dsh_10.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg11{
    background-image: url("../../assets/dsh/dsh_11.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.read-bg12{
    background-image: url("../../assets/dsh/dsh_12.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.event-content-bottom-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-title{
    width: 100%;
    height: 50px;
    line-height: 60px;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    color: #ff7f2e;
}
.event-desc{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #9a9a9a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.content-container{
    width: 100%;
    height: 100%;
}
</style>
